import CoverImageUpload from "./CoverImageUpload";

export default CoverImageUpload